export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11078.d60a5e45.jpg";